import { render, staticRenderFns } from "./role_add.vue?vue&type=template&id=79d03c06&"
import script from "./role_add.vue?vue&type=script&lang=js&"
export * from "./role_add.vue?vue&type=script&lang=js&"
import style0 from "./role_add.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports